export default __webpack_public_path__ + "fdb29bb90d7e69b88f2840fe50cea4d7.svg";